module.exports = __webpack_public_path__ + "static/img/14011C_2_C_20220511_LC.bb77412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14011C_2_C_20220511_LC.png
// module id = rVra
// module chunks = 0